import { SM_DEVICE, PALETTE } from '../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';

const style = MediaQueryStyleSheet.create({
  labelStyle: {
    color: '#A3A4A7',
  
    letterSpacing: 0.35,
    fontSize: 15,
    marginBottom: 12,
  },
  formGroup: {
    marginBottom: 30,
  },
  formGroupErrorMargin: {
    marginBottom: 0,
  },
  'formGroupLastMargin': {
    marginBottom: 40,
  },
  formGroupErrorLastMargin: {
    marginBottom: 0,
  },
  input: {
    paddingVertical: 10,
    paddingRight: 32
  },
  userError: {
    marginTop: 5.75,
    marginBottom: 5.75
  },
  passwordError: {
    marginTop: 10,
    marginBottom: 11.5
  },
  questionMark: {
    position: 'absolute',
    top: '25%',
    right: 10
  },
  questionMarkPopover: {
    position: 'absolute',
    bottom: 28,
    left: -297,
    width: 344,
    zIndex: 1
  },
  questionMarkPopoverArrow: {
    right: 27
  },
  secondaryTextLogin:{
    color:PALETTE.primaryActive
  }
}, {
  [SM_DEVICE]: {
    labelStyle: {
      fontSize: 13
    },
    formGroup: {
      marginBottom: 26,
    },
    'formGroupLastMargin': {
      marginBottom: 36,
    },
    userError: {
      fontSize: 11
    },
    passwordError: {
      fontSize: 11
    },
    questionMarkPopover: {
      position: 'absolute',
      bottom: 28,
      left: -249,
      width: 300,
    },
    questionMarkPopoverArrow: {
      right: 31
    }
  }
});

export default style;
